export default "__VITE_ASSET__Suu1vV1P__"